import Text from './Text';

export default Text;
export * from '@fluentui/react/lib/Text';
